'use strict';

module.exports = require( './lib' ).PhoneNumber;

Object.defineProperty(
	module.exports,
	"__esModule",
	{
		value: true
	}
);

module.exports.default = module.exports;



//////////////////
// WEBPACK FOOTER
// ./~/awesome-phonenumber/index.js
// module id = 475
// module chunks = 0